module.exports = __webpack_public_path__ + "img/shin_light.b9c14bec.png";